"use client";

import Image from "next/image";
import { useTranslations } from "next-intl";

const NAMESPACE = "new-aluminum-extrusion";
const IMAGE_BASE =
	"/image/new-version/more/AluminumExtrusion/why-choose-js-precision-as-your-aluminum-extrusion-services-manufacturer";

const CARDS = [
	{
		keyPrefix: "whyChooseManufacturerCard1",
		image: `${IMAGE_BASE}/versatile-customization.webp`,
		bg: "bg-[#050505]",
	},
	{
		keyPrefix: "whyChooseManufacturerCard2",
		image: `${IMAGE_BASE}/guaranteed-precision.webp`,
		bg: "bg-[#107e03]",
	},
	{
		keyPrefix: "whyChooseManufacturerCard3",
		image: `${IMAGE_BASE}/reliable-delivery.jpg`,
		bg: "bg-[#9ec687]",
	},
] as const;

export default function WhyChooseAluminumExtrusion() {
	const t = useTranslations(NAMESPACE);

	return (
		<section className="bg-white py-8 sm:py-10 md:py-12 lg:py-16">
			<div className="container">
				<header className="mb-6 text-center sm:mb-8 md:mb-10 lg:mb-12">
					<h2 className="mb-3 text-2xl font-bold leading-tight text-black sm:mb-4 sm:text-[30px] md:text-4xl">
						{t("whyChooseManufacturerTitle")}
					</h2>
					<p className="text-sm leading-relaxed text-black md:text-base">
						{t("whyChooseManufacturerDescBefore")}
						<strong className="font-bold">{t("whyChooseManufacturerDescBold")}</strong>
						{t("whyChooseManufacturerDescAfter")}
					</p>
				</header>

				<div className="grid gap-6 md:gap-8 lg:grid-cols-3">
					{CARDS.map((card) => (
						<article
							key={card.keyPrefix}
							className="group flex flex-col overflow-hidden shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-lg"
						>
							<div className="relative aspect-[4/2] w-full overflow-hidden bg-[#f5f7fa]">
								<Image
									src={card.image}
									alt={t(`${card.keyPrefix}ImageAlt`)}
									fill
									className="object-cover transition-transform duration-500 group-hover:scale-105"
									sizes="(max-width: 1024px) 100vw, 33vw"
								/>
							</div>
							<div className={`flex flex-1 flex-col px-5 py-6 sm:px-6 sm:py-7 md:px-7 md:py-8 ${card.bg}`}>
								<span className="mb-3 text-sm font-medium text-white/70">{t(`${card.keyPrefix}Number`)}</span>
								<h3 className="mb-2 text-lg font-bold text-white sm:mb-3 sm:text-xl md:text-2xl">
									{t(`${card.keyPrefix}Title`)}
								</h3>
								<p className="text-sm leading-relaxed text-white/90 md:text-base">
									{t(`${card.keyPrefix}Desc`)}
								</p>
							</div>
						</article>
					))}
				</div>
			</div>
		</section>
	);
}
